import CreateShopArticleRequestModelBase from '../_generated/modelBases/create-shop-article-request-model-base';

export default class CreateShopArticleRequestModel extends CreateShopArticleRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
